import classNames from 'classnames';
import React__default from 'react';
import { getPrefixCls } from '../../../utils/getPrefix.js';

var prefixCls = getPrefixCls('skeleton');
function Avatar(_ref) {
  var size = _ref.size,
    className = _ref.className,
    _ref$dataTestid = _ref.dataTestid,
    dataTestid = _ref$dataTestid === void 0 ? 'skeletonAvatar' : _ref$dataTestid;
  return /*#__PURE__*/React__default.createElement("span", {
    "sl-test-data": dataTestid,
    className: classNames("".concat(prefixCls), "".concat(prefixCls, "-avatar"), className),
    style: {
      width: "".concat(size, "px"),
      height: "".concat(size, "px")
    }
  });
}

export { Avatar };
